import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * A page of Location Users, display-ready.
 *
 * @param {Object} [params] - See `clients/SearchOfficeUsers`.
 * @returns {Promise<import('../types/User').IGetLocationUsersPageResult>}
 */
export const searchOfficeUsers = async (params) => {
  const response = await UsersApi.searchOfficeUsers(params);

  return UserAdapters.toGetLocationUsersPageResult(response);
};
